import { render, staticRenderFns } from "./ShowReferralLink.vue?vue&type=template&id=3c04ff00&scoped=true"
import script from "./ShowReferralLink.vue?vue&type=script&lang=js"
export * from "./ShowReferralLink.vue?vue&type=script&lang=js"
import style0 from "./ShowReferralLink.vue?vue&type=style&index=0&id=3c04ff00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04ff00",
  null
  
)

export default component.exports